<div class="col-md-12 pageTitle">
  <label class="pt-4 pl-4">Inventory Management</label>
</div>
<ul class="nav nav-tabs navBar checkupDashboardNav" id="myTab" role="tablist">
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'ALL' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="ALL"
        id="ALL"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />All
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'CAN-FOOD' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="CAN-FOOD"
        id="CANFOOD"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Can Food
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'CAPSULE' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="CAPSULE"
        id="Capsule"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Capsule
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'DISPOSABLE' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="DISPOSABLE"
        id="
        disposables"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Disposables
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'DROPS' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="DROPS"
        id="drops"
        name="
        drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Drops
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'DRY-SYRUP' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="DRY-SYRUP"
        id="DRYSYRUP"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Dry Syrup
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'EAR-DROPS' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="EAR-DROPS"
        id="EARDROPS"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Ear Drops
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'EYE-DROPS' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="EYE-DROPS"
        id="EYEDROPS"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Eye Drops
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'GEL' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="GEL"
        id="GEL"
        name="
        drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Gel
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'INJECTABLE' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="INJECTABLE"
        id="
        injectables"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Injectables
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'LOTION' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="LOTION"
        id="LOTION"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Lotion
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'OINTMENT' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="OINTMENT"
        id="OINTMENT"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Ointment
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'OINTMENT-SPRAY' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="OINTMENT-SPRAY"
        id="
        OINTMENT"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Ointment & Spray
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'ORAL-DROPS' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="ORAL-DROPS"
        id="ORALDROPS"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Oral Drops
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'ORAL-SPRAY' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="ORAL-SPRAY"
        id="ORALSPRAY"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Oral Spray
    </label>
    <span></span>
  </li>

  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'ORAL-SUPPLEMENTARY' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="ORAL-SUPPLEMENTARY"
        id="
        ORALSUPPLEMENTARY"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Oral Supplementary
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'POWDER-SHAMPOO' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="POWDER-SHAMPOO"
        id="
        POWDER"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Shampoo & Powder
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'PRODUCT' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="PRODUCT"
        id="PRODUCT"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Product
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'SERVICES' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="SERVICES"
        id="SERVICES"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Services
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'SOFTGEL-CAPSULE' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="SOFTGEL-CAPSULE"
        id="
        SOFTGELCAPSULE"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Softgel Capsule
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'SPOT-ON' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="SPOT-ON"
        id="SPOTON"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Spot On
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'SUPPOSITORY' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="SUPPOSITORY"
        id="
        SUPPOSITORY"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Suppository
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'SYRUP' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="SYRUP"
        id="SYRUP"
        name="
        drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Syrup
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'SYRUP-SUPPLEMENT' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="SYRUP-SUPPLEMENT"
        id="
        syrup"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Syrup & Supplement
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'TABLET' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="TABLET"
        id="tablet"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Tablet
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'TOPICAL-POWDER' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="TOPICAL-POWDER"
        id="
        TOPICALPOWDER"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Topical Powder
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'TOPICAL-SPRAY' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="TOPICAL-SPRAY"
        id="
        TOPICALSPRAY"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Topical Spray
    </label>
    <span></span>
  </li>
  <li class="nav-item">
    <label
      class="nav-link navItem col mb-0"
      [ngClass]="{ active: drugCategory === 'VACCINATION-DEWORMING' }"
    >
      <input
        type="radio"
        [(ngModel)]="drugCategory"
        autocomplete="off"
        value="VACCINATION-DEWORMING"
        id="vaccination"
        name="drugCategory"
        class="custom-control-input"
        (change)="categoryChanged(true)"
      />Vaccination & Deworming
    </label>
    <span></span>
  </li>
</ul>
<div class="col-md-12">
  <div class="container">
    <section class="filter pb-2 pt-3">
      <div class="row pt-2 pb-2">
        <div class="d-md-inline-block col-lg-3 col-md-3">
          <label for="searchBox" class="searchBoxlbl"><em class="fa fa-search"></em></label>
          <input type="text" name="searchBox" id="searchBox" class=" form-control input-font searchBox"
            [(ngModel)]="searchBox" placeholder="Enter Item name to search!" (keyup)="searchItem()">
        </div>
        <div class="d-md-inline-block col-lg-2 col-md-2">
          <ng-select [items]="clinicList" bindLabel="name" [clearable]="false" [addTag]="false" [multiple]="false"
            placeholder="Select Clinic" (change)="onClinicChange($event)" [(ngModel)]="clinic_selected">
          </ng-select>
        </div>
        <div class="d-md-inline-block col-md-7 col-lg-7">
          <button class="btn blueButtonAdd wid" (click)="addNewItem()"><em class="fa fa-plus"></em>&nbsp;&nbsp;&nbsp;Add
            New Item</button>
          <!-- </div>
          <div class="d-md-inline-block col-md-2"> -->
          <!-- <button class="btn blueButtonAdd wid ml-2" (click)="consumeItem()"><em
              class="fa fa-magic"></em>&nbsp;&nbsp;&nbsp;Consume Item</button> -->
          <!-- </div>
          <div class="d-md-inline-block col-md-2"> -->
          <button class="btn blueButtonAdd wid ml-2" (click)="bulkUpload()"><em
              class="fa fa-cloud-upload"></em>&nbsp;&nbsp;&nbsp;Bulk Upload</button>
          <!-- </div>
          <div class="d-md-inline-block col-md-2"> -->

          <a href="{{bulkUploadURL}}" class="btn blueButtonAdd bigWid ml-2" target="_self">
            <em class="fa fa-download"></em>&nbsp;&nbsp;Upload Template</a>
        </div>
      </div>
    </section>
    <div class="table-responsive">
      <div class="col-md-12 table table-hover inventoryTable table-bordered">
        <div class="turTable row">
          <div class="cellHeader text-center col-md-3">Name</div>
          <!-- <th class="cellHeader text-center">Mfg Date</th>-->
          <div class="cellHeader text-center col-md-2">Manufacturer</div>
          <!-- <div class="cellHeader text-center col-md-1">Price</div> -->
          <div class="cellHeader text-center col-md-1" *ngIf="drugCategory !== 'OTHERS'">Qty</div>
          <div class="cellHeader text-center col-md-2">Reorder Level</div>
          <!-- <div class="cellHeader text-center col-md-1">Batches</div> -->
          <div class="cellHeader text-center col-md-2">Category</div>
          <div class="cellHeader text-center col-md-2">Action</div>
        </div>
        <!-- <div class="row"> -->
        <ng-container *ngFor="let item of inventoryList; let index=index">
          <app-inv-items [item]="item" [clinicId]="clinicID" (categoryChanged)="categoryChanged($event)">
          </app-inv-items>
        </ng-container>
        <!-- </div> -->
      </div>
    </div>
    <mat-paginator [length]=" length" [pageSize]="pageSize" [pageIndex]="pageNumber" [pageSizeOptions]="pageSizeOptions"
      (page)="pageEvent($event)">
    </mat-paginator>
  </div>
</div>
